import { useEffect, useRef } from 'react'
import styles from './Download.module.scss'
import PageMainTitle from 'components/commons/PageMainTitle'
import { pageMainTitle } from 'components/download/DownloadItems'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

interface CardItem {
  src: string
  alt: string
  title: string
  text: string | JSX.Element
  href: string
  category: ('UX/UI' | 'DX' | 'マーケティング' | '会社情報' | '開発')[]
  categoryClass: ('uxui' | 'dx' | 'marketing' | 'company' | 'development')[]
}

const cardItems: CardItem[] = [
  {
    src: '/images/img/download/ai-ux-sprint/thumbnail_ai_ux_sprint.webp',
    alt: 'AI-UXスプリントサービス紹介資料',
    title: 'AI-UXスプリントサービス紹介資料',
    text: (
      <>
        AI×UX専門家が曖昧な要件を最短2週間でプロトタイプ化。議論を加速し、本質的な体験設計を可能にするアプローチをご紹介します。
      </>
    ),
    href: '/download/ai-ux-sprint/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/rfp/thumbnail_rfp.webp',
    alt: '開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント',
    title: '開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント',
    text: (
      <>
        すぐに使えるテンプレート付！アプリ開発で絶対に失敗できないプロジェクト担当者の方に向けたアドバイスを、この1冊にまとめました
      </>
    ),
    href: '/download/rfp/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/framework-strategy/thumbnail_framework_strategy.webp',
    alt: 'AI時代の開発フレームワーク戦略',
    title: 'AI時代の開発フレームワーク戦略',
    text: (
      <>
        複雑なドメインに強いRDRA/DDD、SDDの活用方法を徹底解説。人材不足・コスト課題を解決し、品質・スピードを向上させます
      </>
    ),
    href: '/download/framework-strategy/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/ai-driven-development/thumbnail_ai_driven_development.webp',
    alt: '経営者が押さえておくべきAI駆動開発ハンドブック',
    title: '経営者が押さえておくべきAI駆動開発ハンドブック',
    text: (
      <>
        人材不足やコスト課題を解決し、スピード・品質・持続性を高めるAI駆動開発の全体像と実践ポイントを解説。AIと人で分担する時代へ
      </>
    ),
    href: '/download/ai-driven-development/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/modernization/thumbnail_modernization.webp',
    alt: '失敗しないAI時代のモダナイゼーション戦略',
    title: '失敗しないAI時代のモダナイゼーション戦略',
    text: (
      <>
        DXやAI活用が進まない本質的な理由とは？老朽化したシステムからの、モダナイゼーションの最新動向をまとめたガイドライン
      </>
    ),
    href: '/download/modernization/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/application-development/thumbnail_application_dev.webp',
    alt: 'アプリ開発 発注前チェックリスト',
    title: 'アプリ開発 発注前チェックリスト',
    text: (
      <>
        アプリ開発の要件定義・予算・ベンダー選定に活用できる資料。発注前に役立つチェックリストもあり、迷ったら読むべき一冊
      </>
    ),
    href: '/download/application-development/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/design-system/thumbnail_ds.webp',
    alt: 'デザインシステム発注ガイド',
    title: 'デザインシステム発注ガイド',
    text: (
      <>
        デザインマネージャーも安心！スケールするプロダクトのための実装から運用まで見据えた、デザインシステムの発注の際に使えるガイドライン
      </>
    ),
    href: '/download/design-system/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/pmm-complete-guide/thumbnail_pmm.webp',
    alt: 'PMMのすべて',
    title: 'PMMのすべて',
    text: (
      <>
        なぜ、プロダクトの成長にPdMとPMMの分業が必要なのか、PMMの役割・導入プロセス・組織設計を体系的に整理した全30ページのホワイトペーパー
        {/* <span className={styles.none}>＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿</span> */}
      </>
    ),
    href: '/download/pmm-complete-guide/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
  {
    src: '/images/img/download/chaos/thumbnail_chaos.webp',
    alt: 'モバイルアプリテクノロジーカオスマップ2025',
    title: 'モバイルアプリテクノロジーカオスマップ2025',
    text: <>モバイルアプリのグロースサイクルを軸とした、国内外の主要な92のソリューションを網羅的に紹介</>,
    href: '/download/mobile-app-technology-chaos-map-2025/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
  {
    src: '/images/img/download/flamingo/thumbnail_flamingo.webp',
    alt: 'UX/UIモダナイゼーションSaaS「flamingo」',
    title: 'UX/UIモダナイゼーションSaaS「flamingo」',
    text: <>システム改修なしでUX/UIを改善する「flamingo」の概要や機能、導入事例、料金について紹介</>,
    href: '/download/flamingo/',
    category: ['UX/UI', '開発'],
    categoryClass: ['uxui', 'development'],
  },
  {
    src: '/images/img/download/prototyping/thumbnail_prototyping.webp',
    alt: 'プロトタイピングサービス',
    title: 'プロトタイピングサービス',
    text: <>3つのプロトタイプの目的や解決できる課題の違い、活用例などをまとめた全16ページの資料</>,
    href: '/download/prototyping/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/pmmchecklist/thumbnail_pmm.webp',
    alt: 'プロダクト開発成功のカギ',
    title: 'プロダクト開発成功のカギ',
    text: 'プロダクトマネジメントのトレンドであるPdM（プロダクトマネージャー）とPMM（プロダクトマーケティングマネージャー）の分業について、全17ページで解説',
    href: '/download/pmmchecklist/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
  {
    src: '/images/img/download/about/thumbnail_about.webp',
    alt: 'UI/UX＆モダナイズ開発サービス紹介ガイド',
    title: 'UI/UX＆モダナイズ開発サービス紹介ガイド',
    text: '私たちが提供するUI/UXやデザインシステム、アプリケーションのモダナイズ開発の特徴から、代表的な3つのプロジェクト事例を紹介',
    href: '/download/about/',
    category: ['UX/UI', '開発'],
    categoryClass: ['uxui', 'development'],
  },
  {
    src: '/images/img/download/design-process/thumbnail_dp.webp',
    alt: 'デザインプロセスガイドブック',
    title: 'デザインプロセスガイドブック',
    text: '開発まで考慮されたUX/UIデザインにおける弊社の考え方や、デザインプロセスの全体について紹介',
    href: '/download/design-process/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/usabilitychecklist/thumbnail_usa.webp',
    alt: 'ユーザビリティチェックリスト',
    title: 'ユーザビリティチェックリスト',
    text: 'noteで3,300いいね獲得！UX/UIデザイナーが実案件から学んだ、本当に役立つUIデザインの法則50',
    href: '/download/usabilitychecklist/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/webaccessibilitychecklist/thumbnail_web.webp',
    alt: 'ウェブアクセシビリティチェックリスト',
    title: 'ウェブアクセシビリティチェックリスト',
    text: '2024年4月より対応が義務化されたウェブアクセシビリティをわかりやすく解説',
    href: '/download/webaccessibilitychecklist/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/growthhack/thumbnail_grow.webp',
    alt: 'サイト改善ソリューション',
    title: 'サイト改善ソリューション',
    text: 'サイトやプロダクトの分析、改善をするためのアプローチ手法やレポートサンプル',
    href: '/download/growthhack/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
  {
    src: '/images/img/download/od/thumbnail_od.webp',
    alt: '継続開発プラン',
    title: '継続開発プラン',
    text: 'アジャイル開発で継続開発する際の体制と進め方',
    href: '/download/od/',
    category: ['開発'],
    categoryClass: ['development'],
  },
  {
    src: '/images/img/download/customer-journy-map/thumbnail_cjm.webp',
    alt: 'カスタマージャーニーマップ',
    title: 'カスタマージャーニーマップ',
    text: 'サービスを利用するユーザーの行動・感情を可視化するフレームワーク',
    href: '/download/customer-journy-map/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/persona/thumbnail_per.webp',
    alt: 'ペルソナ設計',
    title: 'ペルソナ設計',
    text: 'ターゲットとなるユーザーの思考・行動をプロジェクトメンバーで共通理解するフレームワーク',
    href: '/download/persona/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/business-model/thumbnail_bmc.webp',
    alt: 'ビジネスモデルキャンバス',
    title: 'ビジネスモデルキャンバス',
    text: '人、もの、お金を可視化し、事業の構造をとらえるフレームワーク',
    href: '/download/business-model/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
  {
    src: '/images/img/download/lean/thumbnail_lean.webp',
    alt: 'リーンキャンバス',
    title: 'リーンキャンバス',
    text: '新サービスの価値を短時間で言語化するフレームワーク',
    href: '/download/lean/',
    category: ['UX/UI'],
    categoryClass: ['uxui'],
  },
  {
    src: '/images/img/download/value-proposition/thumbnail_value.webp',
    alt: 'バリュープロポジションキャンバス',
    title: 'バリュープロポジションキャンバス',
    text: '事業者側と顧客側の価値提供のギャップを明確にするフレームワーク',
    href: '/download/value-proposition/',
    category: ['マーケティング'],
    categoryClass: ['marketing'],
  },
]

const Download: React.FunctionComponent = () => {
  const sectionRef = useRef<HTMLUListElement>(null)
  const popularItemsRef = useRef<HTMLDivElement[]>([])
  const cardRefs = useRef<HTMLLIElement[]>([])
  const popularItems = [cardItems[0], cardItems[1]]

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll('.popular-item, .card-item, .section_ttl')

    // 初期スタイルの設定
    gsap.set(elements, { opacity: 0, y: 50 })

    // ページ読み込み時にpopular-item要素をアニメーション
    const popularItems = sectionRef.current.querySelectorAll('.popular-item')
    gsap.to(popularItems, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: Power4.easeOut,
      stagger: 0.3,
    })

    // section_ttl要素をアニメーション
    const sectionTitles = sectionRef.current.querySelectorAll('.section_ttl')
    gsap.to(sectionTitles, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: Power4.easeOut,
    })

    // card-item要素はスクロールトリガーでアニメーション
    const cardItems = sectionRef.current.querySelectorAll('.card-item')
    if (window.innerWidth > 819) {
      // PCの場合（時間差をつける）
      cardItems.forEach((element, index) => {
        if (index % 3 === 0) {
          // 一番左のカードは即座に表示
          gsap.to(element, {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: Power4.easeOut,
            scrollTrigger: {
              trigger: element,
              start: 'top 80%',
            },
          })
        } else {
          // 同じ行内の2番目と3番目のカードに時間差を設定
          gsap.to(element, {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: Power4.easeOut,
            scrollTrigger: {
              trigger: element,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
            delay: (index % 3) * 0.2, // 2番目は0.2秒、3番目は0.4秒遅延
          })
        }
      })
    } else {
      // SPの場合（それぞれ個別アニメーション）
      cardItems.forEach((element) => {
        gsap.to(element, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: Power4.easeOut,
          scrollTrigger: {
            trigger: element,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        })
      })
    }

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    }
  }, [])

  return (
    <article className={styles.main} ref={sectionRef}>
      <section className={styles.contents}>
        <PageMainTitle
          pageMainTitle={pageMainTitle}
          paths={[
            { name: 'TOP', url: '/' },
            { name: 'Download', url: '#' },
          ]}
        />
        <section className={`${styles.section} ${styles.section_first}`}>
          <h2 className={`${styles.section_ttl} section_ttl`}>最新資料</h2>
          <div className={styles.list}>
            {popularItems.map((item, index) => (
              <div
                key={index}
                className={`${styles.item} ${styles.popularitem} popular-item`}
                ref={(el) => (popularItemsRef.current[index] = el)}
              >
                <a href={item.href}>
                  <div>
                    <figure className={styles.item_thumbnail}>
                      <img src={item.src} alt={item.alt} />
                    </figure>
                    <h3 className={`${styles.item_ttl} ${styles.item_ttl__recommend}`}>{item.title}</h3>
                    <p className={`${styles.item_text} ${styles.popularitem_text}`}>{item.text}</p>
                    <ul className={`${styles.item_category}`}>
                      {item.category.map((cat, i) => (
                        <li key={i} className={`${styles.categoryItem} ${item.categoryClass[i] || ''}`}>
                          {cat}
                        </li>
                      ))}
                    </ul>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </section>
        <section className={styles.section} id="paginationTarget">
          <h2 className={`${styles.section_ttl} ${styles.section_ttlSec} section_ttl`}>資料一覧</h2>
          <ul className={`${styles.itemlist} ${styles.section_second_wrapper}`} ref={sectionRef}>
            {cardItems.slice(2).map((item, index) => (
              <li
                key={index}
                className={`${styles.item} card-item ${item.categoryClass.join(' ')}`}
                ref={(el) => (cardRefs.current[index] = el)}
              >
                <a href={item.href}>
                  <div>
                    <figure className={styles.item_thumbnail}>
                      <img src={item.src} alt={item.alt} />
                    </figure>
                    <h3 className={styles.item_ttl}>{item.title}</h3>
                    <p className={styles.item_text}>{item.text}</p>
                    <ul className={`${styles.item_category}`}>
                      {item.category.map((cat, i) => (
                        <li key={i} className={`${styles.categoryItem} ${item.categoryClass[i] || ''}`}>
                          {cat}
                        </li>
                      ))}
                    </ul>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default Download
